import { useModal } from '@ebay/nice-modal-react'
import { Link } from '@tanstack/router'
import { useTranslation } from 'react-i18next'
import { styled } from '@linaria/react'
import { useBoundStore } from '../../store/store'
import LoginModal from '../common/log-in-modal'
import CasinoDrawerTabs from './casino-drawer-tabs'
import SportsDrawerTabs from './sports-drawer-tabs'
import CashierDrawerTabs from './cashier-drawer-tabs'
import MyProfileDrawerTabs from './my-profile-drawer-tabs'
import { CASINO_CATEGORIES } from '../../constants/casino'

const StyledLink = styled(Link)`
  color: var(--highlight);
  text-transform: uppercase;
  font-size: 16px;
  padding: 10px 15px 10px 30px;
  width: 100%;
  display: inline-block;
  .theme-dark & {
    border-bottom: 1px solid #1f223c;
  }
  .theme-light & {
    border-bottom: 1px solid #f5f6f9;
  }
`

type TabsProps = {
  closeProfileDrawer: () => void
  showProfileDrawer: () => void
}

const Tabs = ({ closeProfileDrawer }: TabsProps) => {
  const is_agent = useBoundStore(state => state.user.is_agent)
  const is_verified = useBoundStore(state => state.user.is_verified)
  const verif_request_count = useBoundStore(
    state => state.user.verif_request_count,
  )
  const username = useBoundStore(state => state.user.username)
  const logInModal = useModal(LoginModal)
  const { t } = useTranslation(['common', 'drawer', 'kyc'])

  const TABS = [
    {
      label: 'APUESTAS DEPORTIVAS',
      link: '/sports',
      isProtected: false,
    },
    {
      label: 'CASINO',
      link: `/casino/${CASINO_CATEGORIES[0].label}`,
      isProtected: false,
    },
    {
      label: t('promotions', { ns: 'drawer' }),
      link: '/promotions',
      isProtected: false,
    },
    {
      label: 'Mi Perfil',
      link: '/profile',
      isProtected: true,
    },
    {
      label: 'CASHIER',
      link: '/cashier',
      isProtected: true,
    },
    {
      label: t('referral', { ns: 'drawer' }),
      link: '/profile/referral',
      isProtected: true,
    },
    ...(is_agent === '0'
      ? []
      : [
          {
            label: t('affiliate', { ns: 'drawer' }),
            link: 'profile/affiliate',
            isProtected: true,
          },
          {
            label: t('commission', { ns: 'drawer' }),
            link: '/profile/commission',
            isProtected: true,
          },
        ]),
    {
      label: t('free-bonus', { ns: 'drawer' }),
      link: '/profile/free-bonus',
      isProtected: true,
    },
  ] as const

  return (
    <>
      {TABS.map(item =>
        item.link === '/casino' ? (
          <CasinoDrawerTabs
            key={item.link}
            closeProfileDrawer={closeProfileDrawer}
          />
        ) : item.link === '/cashier' ? (
          <CashierDrawerTabs
            key={item.link}
            closeProfileDrawer={closeProfileDrawer}
          />
        ) : item.link === '/profile' ? (
          <MyProfileDrawerTabs
            key={item.link}
            closeProfileDrawer={closeProfileDrawer}
            is_verified={is_verified}
            verif_request_count={verif_request_count}
          />
        ) : item.link === '/sports' ? (
          <SportsDrawerTabs
            key={item.link}
            closeProfileDrawer={closeProfileDrawer}
          />
        ) : (
          <StyledLink
            key={item.link}
            to={item.isProtected && !username ? undefined : item.link}
            onClick={() => {
              closeProfileDrawer()
              item.isProtected && !username && logInModal.show()
            }}
            search={{}}
            params={{}}>
            {item.label}
          </StyledLink>
        ),
      )}
    </>
  )
}

export default Tabs
